import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-universal-softdelete-search-modal',
  templateUrl: './universal-softdelete-search-modal.component.html',
  styleUrls: ['./universal-softdelete-search-modal.component.css']
})
export class UniversalSoftdeleteSearchModalComponent {
  public databaseTables: any = [{ name: 'table 1' }, { name: 'table 2' }];
  public auditTypes: any = [{ name: '(I)nsert' }, { name: '(U)pdate' }, { name: '(D)elete' }];
  public isShowModal: boolean = true;

  public selectedAuditTypes: any[] = [];
  public selectedCreatedByColumn: any = null;
  public selectedUpdatedByColumn: any = null;
  public selectedSoftDeleteColumn: any = null;
  public userValueToSearchFor: string = '';
  public softDeleteTrueExpectedValue: string = '';
  public isSoftDeleteDataTypeString: boolean | null = null;

  @Input() columns: any = [];
  @Output() dialogCloseEmitter = new EventEmitter<boolean>();
  @Output() beginUniversalSoftDeleteSearch = new EventEmitter<any>();

  constructor() {

  }

  dialogClose() {
    this.dialogClosedEmitter();
  }

  dialogClosedEmitter() {
    this.dialogCloseEmitter.emit(false);
  }

  startSearch() {
    this.dialogCloseEmitter.emit(false);
    const a: any = {
      CreatedByUser: this.userValueToSearchFor,
      AuditTypes: 'I,U,D',
      CreatedByUserColumnName: this.selectedCreatedByColumn.Name,
      UpdatedByUserColumnName: this.selectedUpdatedByColumn.Name,
      SoftDeleteColumnName: this.selectedSoftDeleteColumn.Name,
      SoftDeleteTrueExpectedValue: this.softDeleteTrueExpectedValue,
      IsSoftDeleteColumnDataTypeString: this.isSoftDeleteDataTypeString
    };

    console.log(a);
    this.beginUniversalSoftDeleteSearch.emit(a);
  }

  public resetSearch() {
    this.userValueToSearchFor = '';
    this.selectedCreatedByColumn = null;
    this.selectedUpdatedByColumn = null;
    this.userValueToSearchFor = '';
    this.selectedAuditTypes = [];
  }
}
